
import TheMenuLeftSection from "./TheMenuLeftSection.vue";
import TheMenuRightItem from "./TheMenuRightItem.vue";

export default {
  components: { TheMenuRightItem, TheMenuLeftSection },
  props: ["items"],
};
